// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__AI1MQ","content":"styles_content__F98jB","removeButton":"styles_removeButton__vl1Ai","removeIcon":"styles_removeIcon__Ccll8"};